module.exports = __webpack_public_path__ + "static/media/view8-ex1-slow.62de2ff6.mp3";